import type { LngLatBounds } from 'maplibre-gl';

export const isPointInBounds = (
  point?: {
    lng: number;
    lat: number;
  },
  bounds?: LngLatBounds
) => {
  if (!point || !bounds) {
    return false;
  }

  const southWest = bounds.getSouthWest();
  const northEast = bounds.getNorthEast();

  const isAfterWS = southWest.lat <= point.lat && southWest.lng <= point.lng;
  const isBeforeNE = northEast.lat >= point.lat && northEast.lng >= point.lng;

  return isAfterWS && isBeforeNE;
};
